import { render } from "./AdminUsersPage.vue?vue&type=template&id=2f867d1c&scoped=true"
import script from "./AdminUsersPage.vue?vue&type=script&lang=js"
export * from "./AdminUsersPage.vue?vue&type=script&lang=js"

import "./AdminUsersPage.vue?vue&type=style&index=0&id=2f867d1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f867d1c"]])

export default __exports__